module.exports = __webpack_public_path__ + "img/exemplo-cidade.5a9dbed7.jpg";